// Close other dropdowns when opening a new one
document.addEventListener('DOMContentLoaded', function() {
  const allMenuDetails = document.querySelectorAll('header-menu details, .header__submenu details');
  
  allMenuDetails.forEach(detail => {
    const summary = detail.querySelector('summary');
    if (summary) {
      summary.addEventListener('click', function(e) {
        // Close all other open dropdowns at the same level
        const parentContainer = this.closest('.header__inline-menu, .header__submenu');
        if (parentContainer) {
          const allDetailsInContainer = parentContainer.querySelectorAll('details[open]');
          allDetailsInContainer.forEach(otherDetail => {
            if (otherDetail !== detail) {
              otherDetail.removeAttribute('open');
            }
          });
        }
      });
    }
  });

  // Close dropdowns when clicking outside
  document.addEventListener('click', function(e) {
    if (!e.target.closest('header-menu') && !e.target.closest('.header__submenu')) {
      const allOpenDetails = document.querySelectorAll('header-menu details[open], .header__submenu details[open]');
      allOpenDetails.forEach(detail => {
        detail.removeAttribute('open');
      });
    }
  });
});